// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterItem_filter-item__yer1v {
  border-bottom: 2px solid var(--light-grey);
}
.FilterItem_filter-item__yer1v.FilterItem_open__ZRPr9 {
  border-bottom-width: 1px;
}
.FilterItem_filter-item__yer1v .FilterItem_filter-item__title__LiWnx {
  position: sticky;
  top: -16px;
  z-index: 1;
  background-color: var(--background-color-2);
  padding: 16px 0 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.FilterItem_filter-item__yer1v .FilterItem_filter-item__collapse__4DiSo {
  margin-bottom: 16px;
}
.FilterItem_filter-item__yer1v .FilterItem_filter-item__collapse--icon__F-tug {
  margin-left: auto;
  transition: all 0.3s ease;
}
.FilterItem_filter-item__yer1v .FilterItem_title__5-11d {
  color: var(--text-1);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FilterItem_filter-item__yer1v .FilterItem_title--icon__FgnhU svg {
  width: 20px;
  height: 20px;
}
.FilterItem_filter-item__yer1v .FilterItem_title--icon__FgnhU svg path {
  stroke: var(--text-1);
}
.FilterItem_filter-item__yer1v .FilterItem_total-applied__oIcFs {
  background-color: var(--accent-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  font-size: 12px;
  padding: 0 8px;
  color: white;
  height: 22px;
  min-width: 22px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ListFilter/FilterItem/FilterItem.module.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;AACF;AAAE;EACE,wBAAA;AAEJ;AAII;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AAKM;EACE,iBAAA;EACA,yBAAA;AAHR;AAQE;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AAQM;EACE,WAAA;EACA,YAAA;AANR;AAOQ;EACE,qBAAA;AALV;AAWE;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AATJ","sourcesContent":[".filter-item {\n  border-bottom: 2px solid var(--light-grey);\n  &.open {\n    border-bottom-width: 1px;\n    // .filter-item__title {\n    //   border-bottom: 1px solid var(--light-grey);\n    // }\n  }\n  .filter-item {\n    &__title {\n      position: sticky;\n      top: -16px;\n      z-index: 1;\n      background-color: var(--background-color-2);\n      padding: 16px 0 8px;\n      margin-bottom: 8px;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      cursor: pointer;\n    }\n\n    &__collapse {\n      margin-bottom: 16px;\n\n      &--icon {\n        margin-left: auto;\n        transition: all 0.3s ease;\n      }\n    }\n  }\n\n  .title {\n    color: var(--text-1);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    &--icon {\n      svg {\n        width: 20px;\n        height: 20px;\n        path {\n          stroke: var(--text-1);\n        }\n      }\n    }\n  }\n\n  .total-applied {\n    background-color: var(--accent-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 9999px;\n    font-size: 12px;\n    padding: 0 8px;\n    color: white;\n    height: 22px;\n    min-width: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-item": `FilterItem_filter-item__yer1v`,
	"open": `FilterItem_open__ZRPr9`,
	"filter-item__title": `FilterItem_filter-item__title__LiWnx`,
	"filter-item__collapse": `FilterItem_filter-item__collapse__4DiSo`,
	"filter-item__collapse--icon": `FilterItem_filter-item__collapse--icon__F-tug`,
	"title": `FilterItem_title__5-11d`,
	"title--icon": `FilterItem_title--icon__FgnhU`,
	"total-applied": `FilterItem_total-applied__oIcFs`
};
export default ___CSS_LOADER_EXPORT___;
